import { ListTodo, Plus } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { api } from "@/api";
import { useAuth } from "@/auth";
import { NewTicketDialog } from "@/components/pipeline/NewTicketDialog";
import { frDate } from "@/components/pipeline/utils";

export const LeadTickets = ({ lead }) => {
  const [items, setItems] = useState(null);
  const [creating, setCreating] = useState(false);
  const { user } = useAuth();
  const canCreate = user?.role === "admin" || user?.modules?.includes("projets");
  const load = useCallback(() => lead.lead_id && api.get(`/pipeline/leads/${lead.lead_id}/tickets`).then(({ data }) => setItems(data)).catch(() => setItems([])), [lead.lead_id]);
  useEffect(() => { load(); }, [load]);
  return (
    <section className="pl-sheet-block" data-testid="lead-tickets">
      <div className="pl-block-head">
        <h3>Tickets internes <small className="pl-muted">{items ? items.length : "…"}</small></h3>
        {canCreate && <button type="button" className="pl-toggle" onClick={() => setCreating(true)} data-testid="new-ticket-btn"><Plus size={14} /> Nouveau ticket</button>}
      </div>
      {items?.length === 0 && <p className="pl-muted" data-testid="lead-tickets-empty">Aucune tâche de projet n'est liée à ce dossier.</p>}
      <div className="pl-tickets">
        {items?.map((t) => (
          <Link key={t.id} to={`/projets/${t.project_id}?tab=todos&todo=${t.id}`} className="pl-ticket" data-testid={`lead-ticket-${t.id}`}>
            <ListTodo size={15} />
            <span><strong>{t.title}</strong><small>{[t.project_name, t.assignee_name, t.due_date && `échéance ${frDate(t.due_date)}`].filter(Boolean).join(" · ")}</small></span>
            <em className={`pl-ticket-st st-${t.status}`}>{t.status_label}</em>
          </Link>
        ))}
      </div>
      {canCreate && <NewTicketDialog lead={lead} open={creating} onClose={() => setCreating(false)} onCreated={load} />}
    </section>
  );
};
